<div>
  <div class="text-center p-5" *ngIf="!isLoaded">
    <i class="fa fa-spin fa-spinner fa-2x"></i>
  </div>

  <div class="ui-g">
    <div class="ui-g-12">
      <button
        *ngIf="siteSupplierSelected != null"
        pButton
        type="button"
        label="Delete"
        class="ui-button ui-button-danger btn-to-right pull-right"
        (click)="deleteSiteSupplier()"
      ></button>

      <button
        *ngIf="siteSupplierSelected != null"
        pButton
        type="button"
        label="Edit"
        class="ui-button ui-button-default btn-to-right pull-right"
        (click)="editSiteSupplier(siteSupplierSelected)"
      ></button>

      <button
        *ngIf="isLoaded"
        pButton
        type="button"
        label="Add Site"
        class="ui-button ui-button-primary ui-button-success btn-to-right pull-right"
        (click)="createSiteSupplier()"
      ></button>
    </div>
  </div>

  <div *ngIf="isLoaded">
    <p-table
      [value]="inspectionSiteSuppliers"
      [paginator]="false"
      selectionMode="single"
      [(selection)]="siteSupplierSelected"
      [hidden]="!isLoaded"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="siteCode">Site Code</th>
          <th pSortableColumn="siteName">Site Name</th>
          <th pSortableColumn="supplierName">Supplier Name</th>
          <th pSortableColumn="lastUpdated" style="width: 150px">Last Updated</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr (dblclick)="editSiteSupplier(item)" [pSelectableRow]="item">
          <td>{{ item.siteCode }}</td>
          <td>{{ item.siteName }}</td>
          <td>
            <div class="supplier">
              {{ item.supplierName }}
              <i
                *ngIf="!item.isValidSupplier"
                class="pi pi-exclamation-triangle"
                style="transform: scale(1.2)"
              ></i>
            </div>
          </td>
          <td class="text-center">{{ item.lastUpdated | datex : 'DD/MM/YY HH:mm' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Confirm"
  rejectLabel="Cancel"
></p-confirmDialog>

<p-dialog
  [header]="editMode ? 'Edit Inspection Site Supplier' : 'Create Inspection Site Supplier'"
  [(visible)]="showForm"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
  [contentStyle]="{ overflow: 'visible' }"
>
  <div *ngIf="editMode && !siteSupplierSelected?.isValidSupplier" class="warning-message">
    <div class="icon-wrapper">
      <i class="pi pi-exclamation-triangle" style="color: white"></i>
    </div>
    <div class="text-wrapper">
      Supplier {{ siteSupplierSelected?.supplierName }} has been deactivated or does not have the
      inspection task type.
    </div>
  </div>
  <form [formGroup]="createEditForm">
    <div class="ui-g">
      <div class="ui-g-6">
        <input type="hidden" formControlName="id" />
        <div class="input-label">Site Code</div>
        <div class="input-value">
          <input required pInputText formControlName="siteCode" maxlength="8" style="width: 100%" />
        </div>
      </div>
      <div class="ui-g-6">
        <div class="input-label">Site Name</div>
        <div class="input-value">
          <input pInputText formControlName="siteName" maxlength="64" style="width: 100%" />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="input-label">Supplier</div>
        <div class="input-value">
          <p-dropdown [options]="suppliers" formControlName="supplierId"></p-dropdown>
        </div>
      </div>
    </div>
    <div class="d-flex w-100">
      <div class="flex-grow-1 text-right">
        <button
          pButton
          type="button"
          label="Cancel"
          class="ui-button ui-button-default"
          (click)="showForm = false"
        ></button>
        <button
          pButton
          type="button"
          label="Save"
          [disabled]="!createEditForm.valid"
          class="ui-button green-btn"
          (click)="save()"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>
